<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12" color="tertiary">
                    <v-toolbar color="secondary" dark flat>
                        <v-toolbar-title>{{
                            $t('loginView.title')
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                        <v-form @submit.prevent="onLogin">
                            <v-alert
                                text
                                border="left"
                                light
                                color="red"
                                type="error"
                                v-if="errorMessage.length"
                            >
                                {{ errorMessage }}
                            </v-alert>
                            <v-text-field
                                id="email"
                                v-model="credentials.email"
                                :label="$t('loginView.email')"
                                prepend-icon="mdi-email"
                                type="email"
                                color="secondary"
                                error-count="2"
                                required
                                autocomplete="username"
                                :error-messages="emailErrors"
                                @input="$v.credentials.email.$touch()"
                                @blur="$v.credentials.email.$touch()"
                                @keyup="clearServerErrors('login')"
                            />
                            <v-text-field
                                id="password"
                                v-model="credentials.password"
                                :label="$t('loginView.password')"
                                prepend-icon="mdi-form-textbox-password"
                                type="password"
                                color="secondary"
                                class="mt-4"
                                error-count="2"
                                required
                                autocomplete="current-password"
                                @keyup.enter="onLogin"
                                :error-messages="passwordErrors"
                                @input="$v.credentials.password.$touch()"
                                @blur="$v.credentials.password.$touch()"
                                @keyup="clearServerErrors('password')"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="pa-4">
                        <v-spacer />
                        <router-link
                            class="mr-4"
                            :to="{ name: 'forgot-password' }"
                        >
                            {{ $t('loginView.forgotPasswordLinkText') }}
                        </router-link>
                        <v-btn
                            class="elevation-0"
                            large
                            color="secondary"
                            :disabled="!isValid"
                            @click="onLogin"
                            >{{ $t('loginView.loginButton') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import loginValidatorMixin from '@/validators/auth/loginValidator.mixin';

export default {
    name: 'loginView',
    mixins: [loginValidatorMixin],
    data() {
        return {
            credentials: {
                email: '',
                password: ''
            },
            errorMessage: ''
        };
    },
    methods: {
        ...mapActions({ login: 'auth/login' }),

        async onLogin() {
            try {
                this.$v.$touch();

                if (!this.isValid) {
                    return;
                }

                await this.login(this.credentials);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('loginView.title'),
                    text: this.$t('loginView.loginSuccess')
                });

                this.$router.push({ name: 'home' });
            } catch (error) {
                this.errorMessage = '';

                if (this.checkForServerFormErrors(error)) {
                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: this.$t('loginView.title'),
                        text: this.$t('loginView.checkFormErrors')
                    });
                }

                if (error.response.status === 401) {
                    this.errorMessage = this.$t('loginView.invalidCredentials');

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: this.$t('loginView.title'),
                        text: this.$t('loginView.invalidCredentials')
                    });
                }

                console.error(error);
            }
        }
    }
};
</script>
